export class WidgetConfiguration {
  topicId = 0
  legacyTopicId = 0
  userId = 0
  showProfileCrossroads = false
  onlyTopNewest = false
  advertSlotPrefixName = 'anzu_forum_adv_'
  advertSlotPrefixId = 'anzu-forum-adv-'
  advertDisabled = false
  loginBannerPrefixId = 'anzu-forum-campaign-'
  currentUrl: undefined | string = undefined
  loginUrl: undefined | string = undefined
  loginBannerDisabled = false
  loginBannerFallbackDisabled = false
  darkModeEnabled = false
  profileUserEdit = false
  profileEmailEdit = false
  analyticsEventDisabled = false
  subscriptionLinkDisabled = false
  postUserLinkDisabled = false
  postDateLinkDisabled = false
  widgetAutoloadDisabled = false
  scrollToPostOffsetCallback: undefined | string = undefined

  getConfigString = () => {
    return JSON.stringify(this)
  }
}
